import { render, staticRenderFns } from "./bills-water.vue?vue&type=template&id=a7c84e9e&scoped=true&"
import script from "./bills-water.vue?vue&type=script&lang=js&"
export * from "./bills-water.vue?vue&type=script&lang=js&"
import style0 from "./bills-water.vue?vue&type=style&index=0&id=a7c84e9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c84e9e",
  null
  
)

export default component.exports